import { Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";
import { TranslationService } from "@app/services/translation.service";
import "./v-order-buttons.component.scss";


@Component({
    selector: 'v-order-buttons',
    template: require('./v-order-buttons.component.html')
})
export class VOrderButtonsComponent implements OnChanges {

    @Input() moveUpDisabled: boolean;
    @Input() moveDownDisabled: boolean;

    @Output() moveUp = new EventEmitter<void>(); 
    @Output() moveDown = new EventEmitter<void>();

    moveUpTooltip: string;
    moveDownTooltip: string;

    constructor(private readonly translationService: TranslationService) { }

    ngOnChanges(): void {
        this.render();
    }

    onClickMoveUp(): void {
        if (this.moveUpDisabled) {
            return;
        }

        this.moveUp.emit();
    }

    onClickMoveDown(): void {
        if (this.moveDownDisabled) {
            return;
        }

        this.moveDown.emit();
    }

    // ---

    render(): void {
        this.moveUpTooltip = (this.moveUpDisabled) ? null : this.translationService.t("VOrderButtons.MoveUp");
        this.moveDownTooltip = (this.moveDownDisabled) ? null : this.translationService.t("VOrderButtons.MoveDown");
    }
}
